/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useCallback, useState } from 'react';
import { DateRange } from '@material-ui/pickers';
import { Button, Grid, IconButton } from '@material-ui/core';
import { SearchOutlined } from '@material-ui/icons';
import { useStyles } from './styles';
import { useCommonStyles } from '../../../../../styles';
import { DateRangeSelect, HamburgerIcon } from '../../../../../components';
import { FiltersDialog } from './FiltersDialog';

interface Props {
  translation: any;
  dateRange: DateRange<Date>;
  showGroupBy: boolean;
  handleDateRangeChange: (date: DateRange<Date>) => void;
  handleButtonClick?: () => void;
  onGroupByChange: (newOption: string) => void;
}

export const ReportToolbarWithFilters: FC<Props> = ({ translation, dateRange, showGroupBy, handleDateRangeChange, handleButtonClick, onGroupByChange }) => {
  const classes = useStyles();
  const commonClasses = useCommonStyles();
  const [selectedDateRange, setSelectedDateRange] = React.useState<DateRange<Date>>(dateRange);
  const [groupBy, setGroupBy] = useState<string>('');
  const [openFilterDialog, setOpenFilterDialog] = useState(false);

  const requestReport = useCallback(() => {
    if (handleButtonClick) {
      handleButtonClick();
    }
  }, [handleButtonClick]);

  const selectGroupBy = useCallback(
    (option) => {
      let newValue = option;
      if (option === groupBy) {
        newValue = '';
      }
      if (option === '') {
        newValue = '';
      }
      setGroupBy(newValue);
      onGroupByChange(newValue);
    },
    [groupBy, onGroupByChange],
  );

  return (
    <>
      <Grid container direction="row" justify="space-between" alignContent="center" alignItems="center" className={classes.desktopContainer} spacing={1}>
        <Grid item className={classes.filters}>
          <p className={commonClasses.formControlTitle}>{translation.text_6166}</p>
          <DateRangeSelect
            defaultValue={selectedDateRange}
            onRangeChange={(value) => {
              setSelectedDateRange(value);
              handleDateRangeChange(value);
            }}
          />
        </Grid>
        <Grid item className={classes.filters}>
          {showGroupBy && (
            <>
              <p className={commonClasses.formControlTitle}>{translation.text_5718} </p>
              <Grid container direction="row" alignContent="flex-start" alignItems="center" className={classes.groupByContainer}>
                <Grid item xs={4}>
                  <Button
                    className={groupBy === 'partnership' ? classes.selectedGroup : ''}
                    classes={{
                      root: classes.partnership,
                    }}
                    onClick={() => selectGroupBy('partnership')}
                  >
                    {translation.text_6625}
                  </Button>
                </Grid>
                <Grid item xs={4}>
                  <Button
                    className={groupBy === 'clientName' ? classes.selectedGroup : ''}
                    classes={{
                      root: classes.currency,
                    }}
                    onClick={() => selectGroupBy('clientName')}
                  >
                    {translation.text_6635}
                  </Button>
                </Grid>
                <Grid item xs={4}>
                  <Button
                    className={groupBy === 'login' ? classes.selectedGroup : ''}
                    classes={{
                      root: classes.country,
                    }}
                    onClick={() => selectGroupBy('login')}
                  >
                    {translation.text_6643}
                  </Button>
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
        <Grid item style={{ alignSelf: 'flex-end' }}>
          <IconButton onClick={requestReport}>
            <SearchOutlined style={{ color: '#030C21' }} />
          </IconButton>
        </Grid>
      </Grid>
      <Grid container direction="row" justify="space-between" className={classes.mobileContainer} alignItems="center">
        <Grid item xs={11}>
          <p className={commonClasses.formControlTitle}>{translation.text_6166}</p>
          <DateRangeSelect
            defaultValue={selectedDateRange}
            onRangeChange={(value) => {
              setSelectedDateRange(value);
              handleDateRangeChange(value);
              requestReport();
            }}
          />
        </Grid>
        <Grid item xs={1}>
          <IconButton onClick={() => setOpenFilterDialog(true)}>
            <HamburgerIcon />
          </IconButton>
        </Grid>
      </Grid>

      <FiltersDialog
        key={Math.random()}
        open={openFilterDialog}
        groupBy={groupBy}
        translation={translation}
        onClose={() => setOpenFilterDialog(false)}
        applyFilter={(groupBy) => {
          setOpenFilterDialog(false);
          selectGroupBy(groupBy);
        }}
      />
    </>
  );
};
